import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const EndOfFeed: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography
        variant="body2"
        fontWeight="bold"
        align="center"
        color="textDisabled"
      >
        {t('feed:endOfFeed.title')}
      </Typography>
      <Typography variant="body2" align="center" color="textDisabled">
        {t('feed:endOfFeed.subTitle')}
      </Typography>
    </Box>
  );
};
